import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { getPortalContractorSectionRights, JobSectionRights, SecurityRoleTiny, TenantUser } from '@jms/model';
import { Select } from '@jms/utils/util.redux';
import { ApplicationSelectors } from 'apps/portal/src/app/state';
import Enumerable from 'linq';
import { Observable, combineLatest, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PortalContractorRightService {

    private _role: SecurityRoleTiny;
    private _roleRights: { [key: number]: boolean };

    public get role(): SecurityRoleTiny {
        return this._role;
    }

    private readonly selectors = inject(ApplicationSelectors);

    constructor() {

        combineLatest([this.selectors.activeRole$, this.selectors.user$])
            .pipe(
                takeUntilDestroyed(),
                tap(([role, user]) => {
                    this._role = role;

                    this._roleRights = {};

                    if (role != null) {
                        Enumerable.from(role.rights)
                            .forEach(right => {
                                this._roleRights[right] = true;
                            });
                    }
                })
            ).subscribe();
    }


    /** The portal Tasks / Items / SORs rights of the selected company's role, read the way the Allocations guard reads it. */
    public sections(): JobSectionRights {

        return getPortalContractorSectionRights(this._role);
    }

    hasRights(...rights: number[]): boolean {

        if (!rights?.length) return true;

        if (!this._role) return false;

        const result = Enumerable
            .from(rights)
            .all(right => this._roleRights[right]);

        return result;
    }
}
